import Vue from 'vue';
import Vuex from 'vuex';
import persistedstate from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {    
    /** 로그인된 사용자 정보 */
    user: { kind: null },
    /** 설정값 (유지) */
    settings: { lang: '', appLayout: 'light-header', darkmode: false, sidebarMinimize: false },
    /** 공통 로딩중 처리 */
    progress: { title: '', progress: 100 },
    /** 우클릭 및 엑션메뉴 처리 */
    contextmenu: { menu: null },
    /** 언어매핑 처리 (유지) */
    lang: {},
    /** 다국어 수집용 임시 */
    tmpT: {},
    /** 프로필 표시 여부 */
    showProfile: false,
    /** 프로필 표시 여부 */
    showSidebar: false,
    /** 비로그인 서명 시 기존 입력된 인증코드 기억 */
    enteredAuthCode: '',
  },
  mutations: {
    user(state, data) {
      state.user = data ? Object.assign(state.user, data) : { kind: null };
      window.sessionStorage.userId = state.user.userId;
    },
    settings(state, data) {
      state.settings = data ? Object.assign(state.settings, data) : {};
    },
    contextmenu(state, data) {
      state.contextmenu = data ? Object.assign(state.contextmenu, data) : { menu: null };
    },
    progress(state, data) {//data = {title, progress}
      state.progress = data ? Object.assign(state.progress, {title:''}, data) : { progress: 100 };
    },
    lang(state, data) {
      state.lang = data;
    },
    tmpT(state, data) {
      if (state.tmpT[data] == undefined) state.tmpT[data] = '';
    },
    enteredAuthCode(state, data) {
      state.enteredAuthCode = data || '';
    },
    toggleProfile(state, data) {
      typeof data == 'undefined' ? state.showProfile = !state.showProfile : state.showProfile = data;
    },
    toggleSidebar(state, data) {
      typeof data == 'undefined' ? state.showSidebar = !state.showSidebar : state.showSidebar = data;
    },
  },
  actions: {},
  plugins: [
    persistedstate({// 재시작 시에도 유지시킬 state
      paths: ['user', 'settings', 'lang', 'tmpT'],
    }),
  ],
})
